import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearAuthState } from "../../state/auth/authSlice";

function Logout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(clearAuthState());
    navigate("/")
  }, [dispatch, navigate]);

  return null;
}

export default Logout;
